/* 🤖 this file was generated by svg-to-ts */
export const emperorIconInterfaceAlertDiamond1: {
  name: 'interface_alert_diamond_1';
  data: string;
} = {
  name: 'interface_alert_diamond_1',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><path d="M21.707 11.29l-9-9c-.391-.391-1.03-.391-1.42 0l-9 9c-.391.39-.391 1.02 0 1.41l9 9c.19.19.45.29.7.29 .25 0 .51-.1.7-.3l9-9c.39-.39.39-1.03 0-1.42ZM11 7.99h2v6h-2v-6Zm1 9.25c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25 -.56 1.25-1.25 1.25Z"/></svg>`,
};
